<template>
	<svg width="22" height="22" viewBox="0 0 24 24" fill="none" aria-hidden="true">
		<path d="M12 3l9.5 16.5H2.5L12 3z" fill="currentColor"></path>
		<rect x="11" y="9.5" width="2" height="5.5" rx="1" fill="#fff"></rect>
		<circle cx="12" cy="17.4" r="1.2" fill="#fff"></circle>
	</svg>
</template>
